import { render, staticRenderFns } from "./ProOrganizationDetailPage.vue?vue&type=template&id=4c68d73b&scoped=true&"
import script from "./ProOrganizationDetailPage.vue?vue&type=script&lang=ts&"
export * from "./ProOrganizationDetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c68d73b",
  null
  
)

export default component.exports